import { ACTION_TYPES, useServicesDispatch, useServicesState } from "./services-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { ILinkServicesListRequest } from "models/request/link-services-list-request";
import Document from "../../../assets/icons/services-icons/document.svg";
import Money from "../../../assets/icons/services-icons/money-paper.svg";
import Phone from "../../../assets/icons/services-icons/phone.svg";
import Bulb from "../../../assets/icons/services-icons/bulb.svg";
import Users from "../../../assets/icons/services-icons/users.svg";
import Home from "../../../assets/icons/services-icons/home.svg";
import Paper from "../../../assets/icons/services-icons/paper.svg";

export const useServicesController = () => {
    const servicesDispatch = useServicesDispatch();
    const { linkServicesRequest } = useServicesState();

    async function onInit() {
        let request = {} as ILinkServicesListRequest;
        servicesDispatch({
            type: ACTION_TYPES.setLinkServicesRequest,
            payload: request,
        });
        await listLinkServices(request);
    }


    async function listLinkServices(request: ILinkServicesListRequest) {
        try {
            servicesDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });
            const linkServices = await MunicipalPortalAAppService.listLinkServices(request);

            servicesDispatch({
                type: ACTION_TYPES.setLinkServicesResponse,
                payload: linkServices,
            });
            servicesDispatch({
                type: ACTION_TYPES.setLoading,
                payload: false,
            });
        } catch (error) {
            console.log(error);

        }
    }

    function convertIcon(iconNumber: number): string {
        switch (iconNumber) {
            case 1:
                return Document;
            case 2:
                return Phone;
            case 3:
                return Money;
            case 4:
                return Bulb;
            case 5:
                return Users;
            case 6:
                return Home;
            case 7:
                return Paper;
            default:
                return Home;
        }
    }

    const handleOnChange = (e: any) => {
        let term = linkServicesRequest?.term;


        if (e.target.name === "text-field-term") {
            term = e.target.value;

            if (term === null || term === undefined || term === "") {
                (async () => {
                    await listLinkServices({} as ILinkServicesListRequest);

                })()

            }
        }

        servicesDispatch({
            type: ACTION_TYPES.setLinkServicesRequest,
            payload: { term },
        });
    };

    return {
        listLinkServices, handleOnChange, onInit, convertIcon
    };
}